import { Menu } from 'src/app/models/menu.model';

export class LoadMenu {
  static readonly type = '[Menu] Load';
  constructor(public langIso: string) {

  }
}

export class LoadMenuSuccess {

  static readonly type = '[Menu] Load Success';
  constructor(public menu: Menu[]) {

  }
}

export class LoadMenuFail {
  static readonly type = '[Menu] Load Fail';
  constructor(public error: string) { }
}
